

//INITIATE FIREBASE:


import firebase from 'firebase'

import 'firebase/firestore'
import 'firebase/functions'



const dev = {
  apiKey: "AIzaSyA1jHZY7CoGN_LKuR87acgbkRawObxZ45I",
  authDomain: "feedbacklink-dev-885a1.firebaseapp.com",
  databaseURL: "https://feedbacklink-dev-885a1.firebaseio.com",
  projectId: "feedbacklink-dev-885a1",
  storageBucket: "feedbacklink-dev-885a1.appspot.com",
  messagingSenderId: "134361153501",
  appId: "1:134361153501:web:27d8cd5fc82649c7ca0034"
}


const prod = {
  apiKey: "AIzaSyCJ7QocRWck4PanCkIevuXCh1MMFcwxB88",
  authDomain: "feedbacklink-fbl.firebaseapp.com",
  databaseURL: "https://feedbacklink-fbl.firebaseio.com",
  projectId: "feedbacklink-fbl",
  storageBucket: "feedbacklink-fbl.appspot.com",
  messagingSenderId: "848944028555"
}


let firebaseSetup

if (process.env.NODE_ENV === 'development'){
  //  LOCALHOST = DEV
  firebaseSetup = dev
} else {
  //  feedbacklink-dev-885a1.web.app  = TEST: COMMENT OUT IF BUILDING FOR PROD:
  //firebaseSetup = dev
  //ONLY ENABLE THIS LINE IF BUILDING FOR PROD:
  firebaseSetup = prod
}

const app = firebase.initializeApp(firebaseSetup)

if (process.env.NODE_ENV === 'development') {
  //run emulators for faster dev work
  firebase.functions().useFunctionsEmulator("http://localhost:5001");
}

//firebase.functions().useFunctionsEmulator("http://localhost:5001");

export const createCustomerSetTokenSubscribe = firebase.functions().httpsCallable('createCustomerSetTokenSubscribe')
export const inviteViaEmail = firebase.functions().httpsCallable('inviteViaEmail')
export const inviteViaText = firebase.functions().httpsCallable('inviteViaText')
export const signUp = firebase.functions().httpsCallable('signUp')
export const updateEntity = firebase.functions().httpsCallable('updateEntity')
export const customSubscribe = firebase.functions().httpsCallable('customSubscribe')
export const removeMultiLocation = firebase.functions().httpsCallable('removeMultiLocation')
export const addNewLocation = firebase.functions().httpsCallable('addNewLocation')
export const removeClient = firebase.functions().httpsCallable('removeClient')
export const buildWidget = firebase.functions().httpsCallable('buildWidget')
export const getNPS = firebase.functions().httpsCallable('getNPS')
export const processCouponDealCode = firebase.functions().httpsCallable('processCouponDealCode')


export { firebase }

export const storage = firebase.storage()
export const auth = firebase.auth()

const db = firebase.firestore()


//ONE USER HAD ISSUES WITH CONNECTING TO FIRESTORE, SO TRYING THIS AS FIX:
db.settings({experimentalAutoDetectLongPolling: true})
//ONE USER HAD ISSUES WITH CONNECTING TO FIRESTORE, SO TRYING THIS AS FIX



export { db }
